import { getCurrentUserRoles } from 'sonata-static-storage/lib/helpers/user.helpers';
import { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

import type { StateCreator } from 'zustand';

type UserRolesStore = {
  setUserRoles: (token: Record<string, any>) => Promise<void>;
  userRoles: UserRoleInterface[];
};

export const userRolesStore: StateCreator<UserRolesStore, [['zustand/devtools', never]], []> = set => ({
  setUserRoles: async (token: Record<string, any>) => {
    const userRoles = await getCurrentUserRoles(token);
    set({ userRoles }, false, 'userRoles/setUserRoles');
  },
  userRoles: []
});
